window.cloudJumpAudio = {
  sounds: {},
  soundEnabled: true,
  currentMusic: null,
  currentAirplaneSound: null,
  currentHatSound: null,
  currentJetpackSound: null,
  
  init: function() {
    const saved = localStorage.getItem('cloudJumpSoundEnabled');
    if (saved !== null) {
      this.soundEnabled = saved === 'true';
    }
  },
  
  loadSound: function(key, url) {
    const audio = new Audio(url);
    audio.preload = 'auto';
    this.sounds[key] = audio;
  },
  
  play: function(key, loop = false, volume = 1.0) {
    if (!this.soundEnabled || !this.sounds[key]) return null;
    
    const sound = this.sounds[key].cloneNode();
    sound.volume = volume;
    sound.loop = loop;
    sound.play().catch(e => console.warn('Audio play failed:', e));
    return sound;
  },
  
  playMusic: function(key, volume = 0.3) {
    this.stopMusic();
    if (!this.soundEnabled || !this.sounds[key]) return;
    
    this.currentMusic = this.sounds[key].cloneNode();
    this.currentMusic.volume = volume;
    this.currentMusic.loop = true;
    this.currentMusic.play().catch(e => console.warn('Music play failed:', e));
  },
  
  stopMusic: function() {
    if (this.currentMusic) {
      this.currentMusic.pause();
      this.currentMusic.currentTime = 0;
      this.currentMusic = null;
    }
  },
  
  playAirplane: function(volume = 0.4) {
    if (this.currentAirplaneSound) return;
    
    this.currentAirplaneSound = this.play('airplane', true, volume);
  },
  
  stopAirplane: function() {
    if (this.currentAirplaneSound) {
      this.currentAirplaneSound.pause();
      this.currentAirplaneSound.currentTime = 0;
      this.currentAirplaneSound = null;
    }
  },
  
  playHatSound: function(volume = 0.5) {
    if (this.currentHatSound) {
      this.currentHatSound.pause();
      this.currentHatSound.currentTime = 0;
    }
    
    this.currentHatSound = this.play('hat-powerup', true, volume);
  },
  
  stopHatSound: function() {
    if (this.currentHatSound) {
      this.currentHatSound.pause();
      this.currentHatSound.currentTime = 0;
      this.currentHatSound = null;
    }
  },

  playJetpackSound: function(volume = 0.5) {
    if (this.currentJetpackSound) {
      this.currentJetpackSound.pause();
      this.currentJetpackSound.currentTime = 0;
    }
    
    this.currentJetpackSound = this.play('jetpack', true, volume);
  },
  
  stopJetpackSound: function() {
    if (this.currentJetpackSound) {
      this.currentJetpackSound.pause();
      this.currentJetpackSound.currentTime = 0;
      this.currentJetpackSound = null;
    }
  },
  
  toggle: function() {
    this.soundEnabled = !this.soundEnabled;
    localStorage.setItem('cloudJumpSoundEnabled', this.soundEnabled);
    
    if (!this.soundEnabled) {
      this.stopMusic();
      this.stopAirplane();
      this.stopHatSound();
      this.stopJetpackSound();
    }
    
    return this.soundEnabled;
  }
};

window.cloudJumpAudio.init();